// searchTypes.js — public search / suggestions

export const FETCH_SEARCH_SUGGESTIONS_REQUEST =
  "FETCH_SEARCH_SUGGESTIONS_REQUEST";
export const FETCH_SEARCH_SUGGESTIONS_SUCCESS =
  "FETCH_SEARCH_SUGGESTIONS_SUCCESS";
export const FETCH_SEARCH_SUGGESTIONS_FAILURE =
  "FETCH_SEARCH_SUGGESTIONS_FAILURE";

export const CLEAR_SEARCH_SUGGESTIONS = "CLEAR_SEARCH_SUGGESTIONS";

export const SEARCH_SUGGESTIONS_CANCELLED = "SEARCH_SUGGESTIONS_CANCELLED";

export const GET_SEARCH_TRENDING_TERMS_REQUEST =
  "GET_SEARCH_TRENDING_TERMS_REQUEST";
export const GET_SEARCH_TRENDING_TERMS_SUCCESS =
  "GET_SEARCH_TRENDING_TERMS_SUCCESS";
export const GET_SEARCH_TRENDING_TERMS_FAILURE =
  "GET_SEARCH_TRENDING_TERMS_FAILURE";
